export default __webpack_public_path__ + "static/media/no-image.ca7765f7.svg";